/********************************************
 * Accordion on mobile, tabs on desktop
 ********************************************/
function fnFaqList(i, oSection) {
	var oFaq = $(oSection);

	$('a.question', oFaq).on('click',function(){
		$(this).closest('li.area').toggleClass('active');
		$(this).closest('li.area').find('.answer').slideToggle();
	});


}